import styled from "styled-components";

export const StyledInput = styled.div`
  input {
    width: 64px !important;
    height: 58px !important;
    border: ${({ $error }) =>
      $error ? "1px solid red" : "1px solid transparent"};
    border-radius: 12px;
    font-size: 24px;
    margin-right: 10px;
    font-family: ${({ theme }) => theme.palette.typography.fontFamily};
    color: ${({ theme }) => theme.palette.text.primary};
    font-weight: bold;
    background-color: #f5f5f5;
    &:focus {
      outline: none;
      /* color: ${({ theme }) => theme.palette.primary.main}; */
    }
  }
`;
